import { render, staticRenderFns } from "./Carrousel.vue?vue&type=template&id=7bb899e5&"
import script from "./Carrousel.vue?vue&type=script&lang=js&"
export * from "./Carrousel.vue?vue&type=script&lang=js&"
import style0 from "./Carrousel.vue?vue&type=style&index=0&id=7bb899e5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports